/**
 * Accès UI « Abonnements club » (SEPA Connect).
 *
 * Pré-requis métier (rappel) : tables `club_*`, contrainte `paid_club` sur bookings,
 * webhook Connect `/club-subscriptions/webhook`, capability `sepa_debit_payments` sur le compte pro.
 * Voir docs/features/club-subscription-runbook.md
 */

/** Active la carte / onglets « Abonnements club » côté produit. */
export const SHOW_CLUB_SEPA_ENTRY = true;

/**
 * Transferts en masse (CSV) : réservé à l'équipe Rintintin (support / onboarding).
 * L'API POST /club-subscriptions/transfers/bulk reste disponible en interne.
 */
export const SHOW_CLUB_BULK_TRANSFER_UI = false;

/**
 * Invitations en masse (CSV) : réservé à l'équipe Rintintin.
 * L'API POST /club-subscriptions/invitations/bulk reste disponible en interne.
 */
export const SHOW_CLUB_BULK_INVITATION_UI = false;

export function canAccessClubSubscriptionsUi(): boolean {
  return SHOW_CLUB_SEPA_ENTRY;
}
